(function() {

  em.sideHeader = {};

  em.sideHeader.init = function() {
    var nav = document.querySelector(".js-side-navigation");
    var menuNav = document.querySelector('#menu-primary-navigation');
    var menuNavFI = document.querySelector('#menu-primary-navigation-finnish');

    if (nav === null) {
      return false;
    }

    if (menuNav !== null) {
      em.sideHeader.setupMenuLinksWithSubMenus(nav, '#menu-primary-navigation');
    } else if (menuNavFI !== null) {
      em.sideHeader.setupMenuLinksWithSubMenus(nav, '#menu-primary-navigation-finnish');
    } else {
      return false;
    }

    em.sideHeader.setupMenuToggles();
    
    em.sideHeader.closeMenuOnFocusWithin(document.getElementById('c-overlay'));

  };

  em.sideHeader.setupMenuToggles = function() {
    var toggleEl = document.querySelector('.js-navigation-toggle');
    toggleEl.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('has-open-mobile-menu');
    });

    var closeBtn = document.querySelector('.js-navigation-close');
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.toggle('has-open-mobile-menu');
    });
  };

  em.sideHeader.setupMenuLinksWithSubMenus = function(el, menunav) {
    var els = el.querySelectorAll(menunav + ' > li.has-children');
    for (var i = 0; i < els.length; i++) {
      em.sideHeader.toggleSubMenu(els[i], menunav);
    }

    var linksEls = el.querySelectorAll(menunav + ' > li.has-children > a');
    for (var i = 0; i < linksEls.length; i++) {
      em.sideHeader.setLinkListeners(linksEls[i]);
    }
  };

  em.sideHeader.toggleSubMenu = function(el, menunav) {
    if (el.classList.contains('is-active-parent')){
      el.classList.add('is-open');
    }
    
    el.addEventListener('click', function(e) {
      if (!el.classList.contains('is-open')) {
        e.preventDefault();
       
        // Close all before opening
        var siblings = document.querySelectorAll(menunav + ' > li.has-children');
        for (var index = 0; index < siblings.length; index++) {
          
          // Do not close active submenu
          // if (!siblings[index].classList.contains('is-active-parent')){
            siblings[index].classList.remove('is-open');
          // }
        }

        el.classList.add('is-open');
        el.setAttribute('aria-expanded', 'true');
      } else {
        el.classList.remove('is-open');
      }
    });
  };

  em.sideHeader.setLinkListeners = function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
    });
  };

  em.sideHeader.closeMenuOnFocusWithin = function(el) {
    el.addEventListener('click',function() {
        document.body.classList.remove('has-open-mobile-menu', 'has-open-grid-modal');
      },{ passive: true }
    );
  };

})();